'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _computeTimezoneGroups = require('../helpers/computeTimezoneGroups');

var _computeTimezoneGroups2 = _interopRequireDefault(_computeTimezoneGroups);

var _TimezoneAliases = require('../lists/TimezoneAliases');

var _TimezoneAliases2 = _interopRequireDefault(_TimezoneAliases);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cachedTimezoneGroups = void 0;
var previousLocale = void 0;

exports.default = function () {
  if (_I18n2.default.locale === previousLocale) {
    return cachedTimezoneGroups;
  } else {
    var timezoneAliases = (0, _TimezoneAliases2.default)();
    previousLocale = _I18n2.default.locale;
    cachedTimezoneGroups = (0, _computeTimezoneGroups2.default)(timezoneAliases);
    return cachedTimezoneGroups;
  }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/timezone-utils/static-2.97/js/utils/getTranslatedTimezoneGroups.js
// module id = 472
// module chunks = 0